import { render } from "./ContactsTableSettingsMenuV2.vue?vue&type=template&id=4cdce72a&ts=true"
import script from "./ContactsTableSettingsMenuV2.vue?vue&type=script&lang=ts"
export * from "./ContactsTableSettingsMenuV2.vue?vue&type=script&lang=ts"

import exportComponent from "/private/var/folders/vw/10njjg05563b0tmym_8x7zf80000gp/T/deploy/contacts-ui/5f110d9f4ae7a80acfc08dac8edf8b6973fec54c/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.2.37_vue@3.4.18_typescript@4.9.3__webpack@5.87.0_webpack-cli@5.1.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__